import { render, staticRenderFns } from "./Boomgate.vue?vue&type=template&id=7e1a6b27&"
import script from "./Boomgate.vue?vue&type=script&lang=js&"
export * from "./Boomgate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports